import { render, staticRenderFns } from "./HandsFree.vue?vue&type=template&id=f83ca56e&"
import script from "./HandsFree.vue?vue&type=script&lang=js&"
export * from "./HandsFree.vue?vue&type=script&lang=js&"
import style0 from "./HandsFree.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports